<template>
  <section class="w-full h-full flex overflow-hidden">
    <div class="relative p-4 pb-0 box-border flex-1 overflow-hidden bg-bg-common-color">
      <el-scrollbar :style="`height: calc(100% - ${showDygcFooter ? '38px' : '16px'})`" class="w-full h-full bg-white rounded shadow-theme">
        <h1 class="mt-16 h-9 text-xl text-center">承接委托任务，赚取调查费用</h1>
        <div class="text-sm text-center">
          <span class="text-theme-black-650">暂无承接的任务，您可前往</span>
          <span class="text-theme cursor-pointer" @click="toTaskSquare">任务广场</span>
          <span class="text-theme-black-650">承接任务</span>
        </div>
        <div class="text-center mt-8 h-4/5"><img src="@/assets/img/proxy-survey.png" style="width: 70%" /></div>
      </el-scrollbar>
      <!-- 网站协议文案提示 -->
      <DygcFooter class="my-2" v-custom:home="'out_D19_1'" />
    </div>
    <el-scrollbar wrapClass="overflow-x-hidden" class="w-290px border-l border-solid border-theme-black-50 bg-white right h-full">
      <div class="title mr-4 mt-4">
        <h1>委托代理操作步骤</h1>
        <div class="ml-7 mb-2 mt-3">
          <span>
            您需要先成为委托方的代理商才可承接代理任务，<a
              href="https://www.yuque.com/surveywork/help/zqu0mw"
              target="_blank"
              class="text-theme cursor-pointer"
              >操作详情</a
            >
          </span>
        </div>
        <span class="ml-7"
          >委托代理
          <a href="https://www.yuque.com/surveywork/help/ze4ytr" target="_blank" class="text-theme cursor-pointer"
            >执行流程</a
          ></span
        >
      </div>
      <div class="line"></div>
      <div class="title mt-4">
        <h1>委托执行</h1>
        <div class="ml-7 mb-2 mt-3 mr-3">
          <span> 调研工厂团队有超过 12 年的执行经验，承接明察暗访、网络调查、面对面访问等执行任务。 </span>
        </div>
        <div class="ml-7 mt-3">
          <h2 class="text-medium mb-2">我们的优势</h2>
          <div class="relative mr-4">
            <span class="inline-block ml-5">我们自有或第三方共建执行团队超 5000 人</span
            ><i class="el-icon-success absolute top-1 left-0"></i>
          </div>
          <div class="relative mr-4">
            <span class="inline-block ml-5">执行团队人员覆盖全国所有省份</span
            ><i class="el-icon-success absolute top-1 left-0"></i>
          </div>
          <div class="relative mr-4">
            <span class="inline-block ml-5">执行团队成员至少拥有 2 年执行经验</span
            ><i class="el-icon-success absolute top-1 left-0"></i>
          </div>
          <div class="relative mr-4">
            <span class="inline-block ml-5"
              >在城市管理、公共服务、社会调查、文化旅游、资源环境等领域已成功超过执行 20000 个项目</span
            ><i class="el-icon-success absolute top-1 left-0"></i>
          </div>
          <div class="relative mr-4">
            <span class="inline-block ml-5">您无需自建团队，成本大大降低</span
            ><i class="el-icon-success absolute top-1 left-0"></i>
          </div>
          <div class="relative mb-3.5"><span class="inline-block ml-5">……</span></div>
          <div class="mb-2">
            <span
              >更多细节，请查看 <a class="cursor-pointer text-theme" :href="hrefExe" target="_blank">委托执行介绍</a
              ><br />如需咨询，请扫码添加客服咨询</span
            >
          </div>
          <div>
            <img src="/assets/img/code/Mrs.Chai.png" class="float-left" />
            <div class="float-left ml-2.5 mt-5">
              <span><span class="opacity-45">客服顾问：</span>柴女士</span><br />
              <span><span class="opacity-45">联系电话：</span>18511821229</span>
            </div>
          </div>
        </div>
      </div>
    </el-scrollbar>
  </section>
</template>

<script>
import { toTaskSquare } from '@/assets/js/base-platform'
import DygcFooter from 'components/dygc-footer-bottom/index'
import { getBaseDomain } from '@/assets/js/config/env'
export default {
  name: 'empty',
  components: { DygcFooter },
  data() {
    return {}
  },
  computed: {
    showDygcFooter() {
      let config = this.$store.getters.configContextMap.get('home')?.out_D19_1
      return config ? config === "1" : true
    },
    hrefExe() {
      return getBaseDomain() + '/entrustexe'
    }
  },
  methods: {
    // 跳转至任务广场
    toTaskSquare
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-scrollbar__wrap {
  height: 103%;
}
.right {
  .title {
    h1 {
      @apply h-5 leading-5 text-medium-x opacity-85 pl-6 border-l-4 border-solid border-theme;
    }
    span {
      @apply text-medium opacity-85 leading-6 font-normal;
    }
  }
  img {
    width: 88px;
    height: 88px;
  }
  .line {
    @apply w-60 h-px my-4 mx-auto;
    background-color: #e7e9eb;
  }
  i {
    color: #01be69;
  }
}
</style>
